import { MagicWandIcon } from '@carboncopyco/icons';
import { ColorHex, TextBoxEditorTitle } from '@carboncopyco/ui';
import { EditToolDialog } from '../EditToolDialog';
import {
  EditWithAIWithModal,
  type EditWithAIWithModalProps,
} from './EditWithAIWithModal';

export const EditWithAI = ({
  onResponse,
  onClose,
}: EditWithAIWithModalProps) => {
  return (
    <EditToolDialog
      draggable={false}
      onClose={onClose}
      title={
        <div className="flex gap-1.5">
          <MagicWandIcon
            size={16}
            color={ColorHex.primary300}
          />
          <TextBoxEditorTitle
            label="Edit WITH AI"
            uppercase
            fontWeight="font-ds-medium"
            color="text-ds-natural-600"
          />
        </div>
      }
    >
      <div className="flex w-[397px] border-t border-ds-natural-150 px-4 pb-4 pt-5 ">
        <EditWithAIWithModal
          onResponse={onResponse}
          onClose={onClose}
        />
      </div>
    </EditToolDialog>
  );
};
